(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navera-offers"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const chip = event.target instanceof Element ? event.target.closest('[data-copy-code]') : null;
    if (!chip) return;
    const code = chip.getAttribute('data-copy-code') || '';
    const label = chip.querySelector('[data-copy-label]');
    const done = () => {
      if (!label) return;
      label.textContent = 'Copied';
      chip.classList.add('is-copied');
      setTimeout(() => {
        label.textContent = 'Copy';
        chip.classList.remove('is-copied');
      }, 2000);
    };
    if (navigator.clipboard) {
      navigator.clipboard.writeText(code).then(done, done);
    } else {
      done();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
